import { injectIntl } from 'react-intl'
import { PaymentInfoView } from './PaymentInfoView'

const PaymentInfoContainer = injectIntl(PaymentInfoView)

export { PaymentInfoContainer }
